import { render } from "./JourneyEdit.vue?vue&type=template&id=3d80ef5c"
import script from "./JourneyEdit.vue?vue&type=script&lang=js"
export * from "./JourneyEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__